module.exports = __webpack_public_path__ + "src/assets/img/car.c34760cd.svg";